<template>
  <v-container fluid>
    <v-row justify="start" class="mr-lg-16 mr-md-16">
      <v-col cols="12" class="pa-0 ">
        <CommonPanel v-if="loaded">
          <!-- default clid  -->
          <v-row align="start" justify="center">
            <v-col cols="12" md="6">
              <p
                class="text-h4 font-weight-medium text-right fontGrey--text mb-0"
              >
                ברירת מחדל
              </p>
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                dense
                :items="user.profile.main_cid_options"
                :item-text="(item) => `${formated(item.number)}`"
                return-object
                v-model="defaultClId"
                outlined
                :hide-details="true"
                :placeholder="user.profile.main_cid | formatedPhone"
              />
              <!-- To component --- in account details too -->
            </v-col>
            <v-spacer></v-spacer>
           
          </v-row>
          <!-- users clID's - sepparate to component-->
          <v-row>
            <v-col cols="12" md="8" class="text-right">
              <v-list>
                <v-list-item two-line v-for="(item, i) in callerIds" :key="i">
                  <v-list-item-content>
                    <v-list-item-title class="text-right pt-2">
                      <!-- {{ item.cid_name }} -->
                      <v-row align="start">
                        <v-col cols="12" md="4" class="pa-0">
                          <CountrySelect
                            :outlineSelect="false"
                            v-model="callerIds[i].cid_name"
                            @selectCountry="handleSelection"
                            @changeCountry="
                              handleChangeCountry(item, ...arguments)
                            "
                          />
                          <!-- <CountryFlagPhoneInput /> -->
                          <!-- v-model="item.cid_name" -->
                        </v-col>
                        <v-col class="pa-0">
                          <v-list-item-action class="ma-0">
                            <v-btn
                              @click="removeClId(item)"
                              plain
                              text
                              color="fontGrey"
                              x-large
                            >
                              הסר מספר
                              <v-icon color="fontDarkGrey lighten-1" large>
                                mdi-minus
                              </v-icon>
                            </v-btn>
                          </v-list-item-action>
                        </v-col>
                      </v-row>
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      <p class="text-right">
                        {{ item.number }}
                      </p>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <v-btn
                @click="displayAddNewClId = !displayAddNewClId"
                text
                plain
                color="fontGrey"
                class="text-h6 font-weight-bold"
              >
                הוסף מספר מוצג
              </v-btn>
              <!-- add new clID -->
              <v-row v-if="displayAddNewClId" justify="center">
                <v-col cols="12" md="4">
                  <CountrySelect
                    v-model="newClId.country"
                    @selectCountry="handleSelection"
                    :newSelection="true"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    dense
                    :items="user.profile.main_cid_options"
                    :item-text="(item) => `${formated(item.number)}`"
                    return-object
                    v-model="newClId.number"
                    outlined
                    :hide-details="true"
                    :placeholder="formated(user.profile.main_cid)"
                  />
                </v-col>
                <v-col>
                  <v-btn
                    plain
                    text
                    color="success"
                    x-large
                    class="text-h6 font-weight-bold"
                    @click="addClId"
                    :disabled="isUsed"
                  >
                    שמור
                  </v-btn>
                </v-col>
              </v-row>
              <p v-if="isUsed" class="error--text pr-3">
                <!-- allreadyUsed -->
                לא ניתן להגדיר שני מספרים שונים למדינה אחת
              </p>
            </v-col>
          </v-row>
        </CommonPanel>
      </v-col>
    </v-row>
  </v-container>
</template>

<script >
import isEqual from "lodash/isEqual";
import findIndex from "lodash/findIndex";
import set from "lodash/set";
import map from "lodash/map";
import trimStart from "lodash/trimStart";
import { mapState } from "vuex";
import apiCalls from "@/mixins/apiCalls.js";
import fetchCIDs from "@/mixins/fetchCIDs.js";

export default {
  name: "CallerIdsSettings",
  mixins: [apiCalls, fetchCIDs],
  components: {
    CommonPanel: () => import("@/components/CommonComponents/CommonPanel"),
    CountrySelect: () =>
      import("@/components/CommonComponents/Selects/CountrySelect"),
      // CountryFlagPhoneInput: () =>
      // import("@/components/CommonComponents/Selects/CountryFlagPhoneInput"),
  },
  data() {
    return {
      callerIds: [],
      defaultClId: null,
      loaded: false,
      displayAddNewClId: false,
      newClId: {
        countryCode: null,
        country: null,
        number: null,
      },
      // defaultForSms: false,
      // allreadyUsed: false,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
    }),
    isUsed() {
      const isUsed = findIndex(this.callerIds, ["cid_name", this.newClId.countryCode]);
      return (isUsed == -1) ? false : true
    },
  },
  watch: {
    displayAddNewClId() {
      return this.resetNewClIdCountry();
    },
  },
  mounted() {
    this.fetchCallerIds();
  },
  methods: {
    removeClId(item) {
      const temp = map(this.callerIds, (el) => {
        return isEqual(item.cid_name, el.cid_name)
          ? set(el, "to_remove", true)
          : set(el, "to_remove", false);
      });
      this.$set(this, "callerIds", temp);
      this.saveClIds();
    },
    addClId() {
      const newClId = {
        cid_name: this.newClId.countryCode,
        id: -1,
        number: this.newClId.number,
        owner_id: null,
        status: "on",
        to_remove: false,
      };
        this.callerIds.push(newClId);
        this.displayAddNewClId = false;
        this.saveClIds();
    },
    handleChangeCountry(item, country) {
      item.cid_name = trimStart(country.dial_code, "+");
      this.saveClIds();
    },
    handleSelection(country) {
      this.newClId.countryCode = trimStart(country.dial_code, "+");
      this.newClId.country = country;
      this.isUsed
    },
    async saveClIds() {
      this.loaded = false;
      const appAction = false;
      const functionName = "modify_caller_ids";
      const reqBody = {
        caller_ids_to_update: this.callerIds,
        default_clid: this.defaultClId,
        domain_user_id: this.user.profile.domain_user_id,
      };
      const data = await this.makeApiRequest(appAction, functionName, reqBody);
      if (data.error_code === 200) {
        this.loaded = true;
        this.resetNewClIdCountry();
        this.fetchCallerIds();
      }
    },
    resetNewClIdCountry() {
      this.newClId.country = null;
      this.newClId.countryCode = null;
      this.newClId.number = null;
    },
    formated(stringNum) { 
      // console.log('stringNum', stringNum);
      return this.$options.filters.formatedPhone(stringNum)
    },
  },
};
</script>
